export default __webpack_public_path__ + "static/media/NeueMachina-Light.8a402925.woff2";